module.exports = __webpack_public_path__ + "static/img/bcg.0707ea4c.png";